export default __webpack_public_path__ + "static/media/la.7c2c11ce.jpg";